import { Link } from "react-router-dom";
import PathvioLogo from "@/components/PathvioLogo";
import AuthNavLink from "@/components/AuthNavLink";
import Footer from "@/components/Footer";

/**
 * Public layout for legal/static pages — no auth gate, no app sidebar.
 * Simple top bar with the brand mark + sign-in link, centered prose content,
 * and the shared global Footer.
 */
export default function LegalLayout({ children }) {
  return (
    <div className="min-h-screen bg-bone flex flex-col">
      <header className="border-b border-stone/40 bg-bone-soft/50 backdrop-blur">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-brand-link">
            <PathvioLogo size="md" theme="dark" />
          </Link>
          {/* Was a hard-coded "Sign in" that never read auth: a signed-in
              visitor saw it on all five legal pages, for good. */}
          <AuthNavLink
            className="text-sm font-medium text-charcoal hover:text-moss transition-colors"
            data-testid="legal-signin-link"
          />
        </div>
      </header>

      <main className="flex-1 px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-[720px] mx-auto">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
